import { render, staticRenderFns } from "./StatisticsEmployees.vue?vue&type=template&id=06270b98&"
import script from "./StatisticsEmployees.vue?vue&type=script&lang=js&"
export * from "./StatisticsEmployees.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsEmployees.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports